import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, type Observable, switchMap } from 'rxjs';

import { PlatformConfigService } from '../../../features/config/config.service';
import { STORAGE_API_ENDPOINTS } from '../../../features/config/config.type';
import { StorageAiJob, StorageApiCreateJobsPayload, StorageApiCreateJobsResponse } from './ai.type';

@Injectable({
  providedIn: 'root',
})
export class StorageAiService {
  readonly #configService = inject(PlatformConfigService);
  readonly #httpClient = inject(HttpClient);
  readonly #destroyRef = inject(DestroyRef);

  /** Submits an AI inference job for a file.
   * @param payload Contains the file ID and the list of inference types to run.
   */
  createJob(payload: StorageApiCreateJobsPayload): Observable<StorageAiJob> {
    return this.#configService.safelyGetApiUrl$('STORAGE', STORAGE_API_ENDPOINTS.ai.jobs).pipe(
      switchMap((uri) => this.#httpClient.post<StorageApiCreateJobsResponse>(uri, payload)),
      map(({ result }) => result),
      takeUntilDestroyed(this.#destroyRef),
    );
  }
}
